export default __webpack_public_path__ + "static/media/my_words.146edeb4.png";